import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const NavigationBreadcrumbs = ({ businessName = null }) => {
  const location = useLocation();

  const shouldShowBreadcrumbs = () => {
    return location?.pathname === '/business-profile' && businessName;
  };

  if (!shouldShowBreadcrumbs()) {
    return null;
  }

  return (
    <nav className="bg-white border-b border-gray-200 py-3 px-4 sm:px-6 lg:px-8" aria-label="Breadcrumb">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-2 flex-wrap">
          {/* Explorar Link */}
          <Link 
            to="/business-directory" 
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-primary transition-all duration-200"
          >
            <Icon name="Search" size={16} className="flex-shrink-0" />
            <span>Explorar</span>
          </Link>
          
          {/* Separator */}
          <Icon name="ChevronRight" size={16} className="text-gray-400 flex-shrink-0" />
          
          {/* Current Business */}
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-primary/5 text-sm font-medium text-primary">
            <Icon name="Store" size={16} className="flex-shrink-0" />
            <span className="truncate max-w-[200px] sm:max-w-none">{businessName}</span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavigationBreadcrumbs;